export default {
  grid: {
    container: '130rem',
    gutter: '3.2rem'
  },
  border: {
    radius: '0.4rem'
  },
  font: {
    family:
      "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    light: 100,
    normal: 300,
    bold: 500,
    ultra: 700,
    top: 900,
    sizes: {
      xsmall: '1.2rem',
      small: '1.4rem',
      medium: '1.6rem',
      large: '1.8rem',
      xlarge: '2.0rem',
      xxlarge: '3.5rem',
      huge: '5.2rem'
    }
  },
  colors: {
    primary: '#00B2A9',
    secondary: '#464646',
    mainBg: '#1E1E1E',
    altBg: '#464646',
    white: '#FFFFFF',
    black: '#000000',
    info: '#FF8200',
    gray: '#707070',
    darkGray: '#4F4F4F',
    border: '#272727',
    form: '#2E2E2E',
    copy: '#FBFBFB',
    hover: {
      primary: '#00B2A9AF',
      secondary: '#FA793FB0',
    },
  },
  spacings: {
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem'
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  },
  transition: {
    default: '0.3s ease-in-out',
    fast: '0.1s ease-in-out'
  }
} as const
